import type {PS} from '@wix/document-services-types'

export default {
    /**
     * @param {PS} ps
     * @returns {boolean}
     */
    get(ps: PS): boolean {
        return ps.extensionAPI.accessibility.visualFocus.get()
    },
    /**
     * @param {PS} ps
     * @param {boolean} enabled
     */
    set(ps: PS, enabled: boolean) {
        ps.extensionAPI.accessibility.visualFocus.set(enabled)
    }
}
